export function intranetProfileInfo() {
    const $profiles = jQuery('.js-intranet-profile');

    if (!$profiles.length) {
        return;
    }

    function updateProfileLinks(initials) {
        $profiles.each(function () {
            const profileUrl = jQuery(this).data('profile-url');

            if (!profileUrl || !initials) {
                return;
            }

            jQuery(this)
                .find('.navbar-profile_link')
                .attr('href', profileUrl + '?initials=' + initials);
        });
    }

    function updateProfileMarkup(user) {
        jQuery('.profile-name').html(user.name);
        jQuery('.profil-image').attr('src', user.image);
        updateProfileLinks(user.initials);
    }

    jQuery(function () {
        // Cachen bruges kun, hvis den hører til den bruger, klartekst-cookien angiver. Ellers (cookien er
        // manipuleret, slettet af IntranetMaster eller tilhører en tidligere bruger) spørges serveren.
        const cached = readCachedUser();
        const initials = Cookies.get('INTRANET-initials');

        if (cached && initials && String(cached.initials).toLowerCase() === String(initials).toLowerCase()) {
            updateProfileMarkup(cached);
            return;
        }

        getLoggedInUserInfo();
    });

    function readCachedUser() {
        try {
            const loggedUser = Cookies.get('INTRANET-LoggedInUser');
            return loggedUser ? JSON.parse(loggedUser) : null;
        } catch (e) {
            return null;
        }
    }

    // Uden initialer svarer serveren med den bruger, login-cookien (AuthTokenIntranet) tilhører, så
    // headeren viser den rigtige bruger uafhængigt af klartekst-cookien. 401 = ikke logget ind.
    function getLoggedInUserInfo() {
        jQuery.ajax({
            type: 'GET',
            url: '/api/LdapUser/GetUserByInitials',
            dataType: 'json',
            contentType: 'application/json',
            data: {
                rootid: jQuery('body').data('id')
            },
            success: function (response) {
                if (!response || !response.userAlias) {
                    return;
                }
                const lastInitial = response.lastName ? ' ' + response.lastName[0] + '.' : '';
                const user = {
                    initials: response.userAlias,
                    name: (response.firstName || '') + lastInitial,
                    image: response.profileImage,
                    created: response.created,
                    userId: response.userId
                };

                updateProfileMarkup(user);

                const date = new Date();
                date.setHours(date.getHours() + 5);

                Cookies.set('INTRANET-LoggedInUser', JSON.stringify(user), {
                    expires: date
                });
            },
            error: function () {
                console.log('Whoops something went wrong! update profile');
            }
        });
    }
}

export default intranetProfileInfo;